<template>
  <div v-if='loading'>
    <oil-form
        :title='formTitle'
        :items='waybill'
        :keys='keys'
        :createForm='true'
        @AppendixId='changeAppendix'
        @EmpowermentId='changeEmpowerment'
        @OrderId='changeOrder'
        @VehicleTrailer1='changeVehicleTrailer1'
        @VehicleTrailer2='changeVehicleTrailer2'
        :formCallback='formCallback'
    >
      <template v-slot:ShipmentDate='{rules,input}'>
        <div class='parent'>
          <date-picker
              v-if='waybill.ShowShipmentDate'
              itemKey='ShipmentDate'
              :item='waybill'
              :keys='startDateKeys'
              :vInput='input'
              :attr='startDateKeys.attrs'
          />
          <v-text-field v-else
                        label='Дата ТТН'
                        v-model='waybill.ShipmentDescription'
                        outlined dense :disabled='!input.isEdit'
          />
          <v-checkbox class='absolute'
                      hide-details
                      :disabled='!input.isEdit'
                      v-model='waybill.ShowShipmentDate'
                      outlined
                      dense
          ></v-checkbox>
        </div>
      </template>
      <template v-slot:Terminal.Id='{input}'>
        <div class='parent'>
          <v-autocomplete
              v-model='waybill.Terminal'
              :items='terminals'
              :disabled='!input.isEdit'
              clearable
              @change='changeTerminal'
              dense
              outlined
              hide-selected
              item-value='Id'
              item-text='Name'
              label='Пункт погрузки'
              return-object
          />
          <v-checkbox
              class='absolute'
              v-model='waybill.ShowShipmentDate'
              hide-details
              outlined
              dense
          />
        </div>
      </template>
      <template v-slot:Buyer.Id='{rules}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            clearable
            :rules='[...rules]'
            dense
            outlined
            @change='changeBuyer'
            hide-selected
            :value='waybill.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id='{rules}'>
        <v-autocomplete
            :items='contracts$'
            v-stream:keyup.native='searchContract$'
            hide-no-data
            :rules='[...rules]'
            clearable
            @change='changeContract'
            dense
            outlined
            :value='waybill.Contract.Number'
            hide-selected
            item-text='Number'
            label='Выбрать договор'
            return-object
        ></v-autocomplete>
      </template>


      <template v-slot:NoTransport='{rules,input}'>
        <v-radio-group v-model='waybillNoTransport' class='py-0 my-0'>
          <v-radio label='с транспортом' :value='false' ></v-radio>
          <v-radio label='без транспорта' :value='true' ></v-radio>
        </v-radio-group>
      </template>
      <template v-slot:Vehicle.Volume='{rules,input}'>
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='vehicles$'
            v-stream:keyup.native='searchVehicle$'
            hide-no-data
            v-model='waybill.Vehicle.Id'
            :rules='[...rules]'
            :disabled='!input.isEdit'
            clearable
            @change='changeVehicle'
            dense
            outlined
            hide-selected
            item-text='Volume'
            item-value='Id'
            label='Автомобиль'
            return-object
        >
          <template v-slot:item='{item}'>
            <template>
              <v-list-item-content>
                {{ item.Name }}: "{{ item.ModelRegistrationNumber }}"
                Литраж: "{{ item.Volume }}"
              </v-list-item-content>
            </template>
          </template>
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='1024'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-dump-truck'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать автомобиль'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='vehicle.Name' outlined dense label='Название' />
                    <v-text-field v-model='vehicle.Model' outlined dense label='Модель' />
                    <v-text-field v-model='vehicle.ModelRegistrationNumber' outlined dense
                                  label='Гос. регистрационный номер авто' />
                    <v-text-field v-model='vehicle.Volume' outlined dense label='Литраж' />
                    <v-btn @click='saveVehicle(vehicle,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Driver.Name='{rules,input}' class='hover'
      >
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='drivers$'
            v-stream:keyup.native='searchDriver$'
            hide-no-data
            v-model='waybill.Driver.Id'
            :disabled='!input.isEdit'
            :rules='[...rules]'
            clearable
            @change='changeDriver'
            dense
            outlined
            hide-selected
            item-value='Id'
            item-text='Name'
            label='Водитель'
            return-object
        >
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='800'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-transit-transfer'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать водителя'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='driver.Name' outlined dense label='Имя' />
                    <v-btn @click='saveDriver(driver,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Vehicle.Trailer1='{input}'>
        <v-text-field
            v-model='waybill.Vehicle.Trailer1'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №1'
            outlined
            dense
        />
      </template>
      <template v-slot:Vehicle.Trailer2='{input}'>
        <v-text-field
            v-model='waybill.Vehicle.Trailer2'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №2'
            outlined
            dense
        />
      </template>
      <template v-slot:Convoy='{input}'>
        <v-text-field
            v-model='waybill.Convoy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Сопровождающий'
            outlined
            dense
        />
      </template>
      <template v-slot:Carrier='{input}'>
        <v-text-field
            v-model='waybill.Carrier'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Перевозчик'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentDoneBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentDoneBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск произвел'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentAllowedBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentAllowedBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск разрешил'
            outlined
            dense
        />
      </template>
      <template v-slot:WaybillNote='{input}'>
        <v-text-field
            v-model='waybill.WaybillNote'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Путевой лист'
            outlined
            dense
        />
      </template>
      <template v-slot:Seals='{input}'>
        <v-text-field
            v-model='waybill.Seals'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Пломбы'
            outlined
            dense
        />
      </template>
      <template v-slot:Product='{input}'>
        <OilProduct
            :input='input'
            :contract='waybill.Contract'
            :item='waybill.Item'
        />
      </template>
    </oil-form>
  </div>
</template>

<script>

import { companiesService } from '@/services/CompaniesService.js'
import { waybillService } from '@/services/WayBillService'
import { orderService } from '@/services/OrderService'
import { vehicleService } from '@/services/VehicleService'

import Waybill from './model/waybill'
import { ProductCalc } from '@/utils/functions/Product'

import create from './globalFunctionsInThisDirectory.js'


export default {
  mixins: [create],
  data() {
    return {
      waybillNoTransport: false
    }
  },
  methods: {
    driveAway(value) {
      const number = parseFloat(value).toFixed(2)
      if (isNaN(number)) return

      const result = number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
      this.waybill.Number = result
    },
    async formCallback(waybill, input) {

      input.isEdit = false

      const item = waybill.Item
      const liter = parseFloat(item.AmountInLitre)
      const volume = parseFloat(waybill.Vehicle.Volume)

      // if (isNaN(liter) && isNaN(volume)) {
      //   this.$notify({
      //     group: 'mgs',
      //     type: 'error',
      //     title: `некорректные данные`
      //   })
      //   input.isEdit = true
      //   return
      // }
      waybill.TotalExcise = ProductCalc.TotalExcise(item)
      waybill.VAT = ProductCalc.TotalNds(item)
      waybill.NetTotal = ProductCalc.PriceClearTons(item)
      waybill.TotalNproductsoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.TotalPriceInText = item.TotalPriceInText
      waybill.Total = ProductCalc.TotalPrice(item)
      waybill.TotalNoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.Item.NetPricePerTonne = ProductCalc.PriceClearNdsPrice(item)
      const response = await waybillService.create(waybill)

      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }
      this.openPdf(id, 'waybill/print')
      await this.$router.push({
        name: 'waybill-update',
        params: { id: id }
      })
    }
  },
  async created() {
    this.vehicles$ = []
    this.drivers$ = []
    const tmp = await vehicleService.getById({ isOwn: true })
    this.driverKey.VehicleId.attrs.items = tmp.data
    this.keys['Appendix.Id'].attrs.readonly = false
    this.keys['Empowerment.Id'].attrs.readonly = false
    this.keys['Order.Id'].attrs.readonly = false
    this.reset()
    this.waybill = new Waybill().wayBill
    const companies = await companiesService.getAll()
    this.buyers = companies.data
    const seller = await companiesService.seller()

    const vehiclesOwn = await vehicleService.getAll({ isOwn: true })

    this.vehicles$ = vehiclesOwn.data || []

    const {
      CompanyName,
      Address
    } = seller.data
    this.waybill.SellerNameWithAddress = `${CompanyName} ${Address}`
    this.waybill.ShowShipmentDate = true
    const orders = await orderService.getOrders()

    this.orders = orders.data

    this.readonly = false
    console.log(this.waybill)
    this.loading = true
  },
  watch: {
    terminals(terminals) {
      this.keys['Terminal.Id'].attrs.items = terminals
    },
    waybillNoTransport(val){
      this.waybill.NoTransport = val
    }
  }
}
</script>

<style>


.parent {
  position: relative;
}

.absolute {
  position: absolute;
  left: 100%;
  right: 0;
  top: -12px;
}

.transport {
  display: none !important;
}
</style>
